export default {
  mainVenue: [
    {
      time: '13:10-13:40',
      affair: {
        type: '主题演讲',
        title: '御风飞翔',
        speakers: [
          {
            name: '韩牧',
            title: '懒熊体育创始人&CEO',
          },
        ],
      },
    },
    {
      time: '10:40-14:10',
      affair: {
        type: '互动对话',
        title: '2022年的第一堂体育商业「李」论课',
        speakers: [
          {
            title: '',
            name: '',
          },
          {
            title: '',
            name: '',
          },
          {
            title: '',
            name: '',
          },
          {
            title: '',
            name: '',
          },
          {
            title: '',
            name: '',
          },
        ],
      },
    },
    {
      time: '14:10-14:50',
      affair: {
        type: '圆桌论坛',
        title: '风起新物种：体育产业的场景革命',
        speakers: [],
      },
    },
    {
      time: '14:50-15:10',
      affair: {
        type: '主题演讲',
        title: '赛场外的全新舞台',
        speakers: [],
      },
    },
    {
      time: '15:20-16:00',
      affair: {
        type: '圆桌论坛',
        title: '风起热冰雪：冬奥红利下的冰雪消费升级',
        speakers: [],
      },
    },
    {
      time: '16:00-16:20',
      affair: {
        type: '主题演讲',
        title: '蓄势而上，破局重生——体育教育的进化之路',
        speakers: [
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '16:20-16:40',
      affair: {
        type: '主题演讲',
        title: '数字体育和年轻人对话的方式',
        speakers: [],
      },
    },
    {
      time: '16:50-17:30',
      affair: {
      type: '圆桌论坛',
      title: '风起好内容：算法时代的IP制造法则',
      speakers: [],
      },
    },
    {
      time: '17:30-18:10',
      affair: {
        type: '圆桌论坛',
        title: '风起大教育：多重政策利好下的体育教育迭代',
        speakers: [],
      },
    },

  ],
  parallelVenue: [
    // {
    //   time: '14:30-14:40',
    //   affair: {
    //     type: '开场',
    //     title: '',
    //     speakers: [],
    //   },
    // },
    {
      time: '14:40-15:00',
      affair: {
        type: '年度创新品牌',
        title: '',
        speakers: [],
      },
    },
    {
      time: '15:00-15:40',
      affair: {
        type: '年度营销品牌',
        title: '',
        speakers: [
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '15:40-16:20',
      affair: {
        type: '年度产业人物',
        title: '',
        speakers: [
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
  ],
  awards: [
    {
      time: '',
      affair: {
        type: '中国体育产业年度产业人物',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '',
      affair: {
        type: '中国体育产业年度营销奖',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '',
      affair: {
        type: '中国体育产业年度创新奖',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
  ],
  workshop: [
    {
      time: '',
      affair: {
        type: '体育创新与城市发展',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '',
      affair: {
        type: '体育营销的技术变革',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
    {
      time: '',
      affair: {
        type: '体育科技的颠覆应用',
        title: '',
        speakers: [
          {
            name: ``,
            title: '',
          },
          {
            name: '',
            title: '',
          },
          {
            name: '',
            title: '',
          },
        ],
      },
    },
  ],
};
